<template>
    <div>
        <PortofolioSteps :current-step="1" v-if="type === 'cart'"></PortofolioSteps>
        <template v-if="cartProcedures && cartProcedures.length > 0">
            <template  v-if="type === 'cart'">
                <v-card-title class="font-weight-black text-family-bold">
                    Trámites por pagar
                </v-card-title>
                <v-card-subtitle class="text-family font-weight-black">
                    Tienes la opción de pagar el total de trámites enviados a Mis Pagos o los que selecciones.
                </v-card-subtitle>
            </template>
            <template  v-else>
                <v-card-title  class="text-family-bold font-weight-black">
                    Trámites en espera de pago
                </v-card-title>
            </template>
        </template>
        <template v-else >
            <v-card-title class="mt-4 text-family-bold font-weight-black">
                * No hay trámites disponibles a pagar.
            </v-card-title>
        </template>

        <v-card  v-for="(procedure, index) in cartProcedures" :key="'procedure'+index" class="mb-4">
            <v-list two-line>
                <template v-for="(procedureItem, index) in procedure.tramitesCarrito" >
                    <v-divider
                        v-if="index > 0"
                        class="mx-4"
                        :key="'divider'+procedureItem.id"
                    />
                    <v-list-item :key="'subprocedure'+procedureItem.id">
                        <!--<div class="d-flex">-->
                        <v-list-item-content class="flex-grow-1 flex-shrink-1" style="flex: none;">
                            <v-list-item-title class="text-h6 text-family-bold font-weight-black">
                                {{procedureItem.nombre_tramite}}
                            </v-list-item-title>
                            <v-list-item-subtitle class="mb-2 text-family font-weight-black">
                                {{ procedureItem.descripcion }}
                            </v-list-item-subtitle>
                            <v-list-item-title class="text-h6 my-1 text-family-bold font-weight-black">
                                {{ procedureItem.precio| currency}}
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-content v-if="index === 0" class="px-2" style="flex: none; text-align: center">
                            <div class="flex flex-row mr-2" style="text-align: right">
                                <v-tooltip bottom v-if="type==='cart'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            fab small color="" text class="mx-1"
                                            @click="moveToWishlist(procedure.tramiteCarritoId)"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon small color="">
                                                fas fa-clock
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Pagar después</span>
                                </v-tooltip>
                                <v-tooltip bottom  v-else>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            fab small text color="" class="mx-1"
                                            @click="moveToCart(procedure.tramiteCarritoId)"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon small color="">
                                                fas fa-briefcase
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Pagar ahora</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            fab small text color="" class="mx-1"
                                            @click="removeProcedure(procedure.tramiteCarritoId)"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon small color="">
                                                fas fa-trash
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Eliminar de Mis Pagos</span>
                                </v-tooltip>
                            </div>
                            <!-- <div class="text-subtitle-2" style="text-align: right">
                                Trámite Id: {{procedureItem.tramite_id}}
                            </div> -->
                        </v-list-item-content>
                    </v-list-item>
                </template>

            </v-list>
            <v-card-actions class="pa-0" v-if="procedure.totalTramitesCarrito > 5">
                <v-btn
                    color="normal"
                    width="100%"
                    height="50"
                    @click="getProcedureAllItems(procedure.tramiteCarritoId, index, type)"
                >
                    Ver todos los trámites ({{procedure.totalTramitesCarrito}} elementos)
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import PortofolioSteps from "../PortofolioSteps";

export default {
    name: 'ProceduresToPay',
    props: ['cartProcedures', 'type', 'getProcedureAllItems', 'moveToCart', 'moveToWishlist', 'removeProcedure'],

    components: {
        PortofolioSteps
    }
};
</script>


<style scoped>
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}

.text-family{
    font-family: 'PoppinsRegular' !important;
}
.text-family-bold{
    font-family: 'PoppinsBold' !important;
}

</style>